var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warehousesData.length)?_c('ez-select',{ref:"select",staticClass:"input-group",attrs:{"name":_vm.name,"disabled":_vm.disabled,"isFullWidth":_vm.isFullWidth,"value":_vm.selected,"selected":_vm.selected,"label":_vm.label,"options":_vm.warehousesData,"data-cy":_vm.dataCy},on:{"change":_vm.onChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }